<template>
    <kgr-form-scaffold
        :pending="pending"
        :with-delete-button="true"
        edit-mode
        @primaryBtnClicked="addArea"
        @backBtnClicked="redirectToOverview"
        @deleteBtnClicked="deleteArea"
    >
        <kgr-area-basic-data-provider
            :area-id="areaId"
            :location-id="locationId"
            :callback="onAreaLoaded"
        >
            <kgr-area-create-form
                :area="area"
                :error="error"
                @enter="addArea"
            />
        </kgr-area-basic-data-provider>
    </kgr-form-scaffold>
</template>

<script>

import Area from '../../js/dto/resource/Area';
import AreaBasicDataForm from '../../components/resource/AreaBasicDataForm';
import AreaBasicDataProvider from '../../components/data-provider/AreaDataProvider';
import AreaRepository from '../../js/repository/AreaRepository';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import Location from '../../js/dto/resource/Location';

export default {
    components: {
        'kgr-area-basic-data-provider': AreaBasicDataProvider,
        'kgr-area-create-form': AreaBasicDataForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        areaId: {
            type: String,
            required: true,
        },
        locationId: {
            type: String,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            area: new Area(),
            location: new Location(),
            error: new Error()
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onAreaLoaded(loadedArea) {
            this.area = loadedArea;
        },
        addArea() {
            if (this.pending) {
                return;
            }

            this.pending = true;

            AreaRepository.update(this.area, this.locationId)
                .then(() => {
                    this.$notify.success('Bereich aktualisiert', {}, { saveInSession: true });
                    window.location = `/backend/resources/locations/${this.locationId}/areas/${this.area.id}/edit`;
                })
                .catch(error => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        deleteArea() {
            if (this.area.isDeletable) {
                showConfirm(this.$t('confirm'), this.$t('Soll der Bereich wirklich gelöscht werden?', {}), () => {
                    this.pendingRemove = true;
                    AreaRepository.delete(this.locationId, this.areaId)
                        .then(() => {
                            this.$notify.success('Der Bereich wurde gelöscht');
                            this.pendingRemove = false;
                            this.redirectToOverview();
                        })
                        .catch(() => {
                            this.$notify.error('Der Bereich konnte nicht gelöscht werden');
                            this.pending = false;
                        }
                        );
                }, 'Ok');
            }
            else {
                showConfirm(this.$t('confirm'), this.$t('area.archive.confirm', {}), () => {
                    this.pendingRemove = true;
                    AreaRepository.archive(this.locationId, this.areaId)
                        .then(() => {
                            this.$notify.success('Der Bereich wurde archiviert');
                            this.pendingRemove = false;
                            this.redirectToOverview();
                        })
                        .catch(() => {
                            this.$notify.error('Der Bereich konnte nicht archiviert werden');
                            this.pending = false;
                        }
                        );
                }, 'Ok');
            }

        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}



</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
